var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimerDefault = function SvgTimerDefault(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 5a59 59 0 1 0 0 118A59 59 0 0 0 64 5m0 10a49 49 0 1 1 0 98 49 49 0 0 1 0-98"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 46,
    x: 60,
    y: 25,
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 23.25,
    height: 14,
    x: 105.2,
    y: 4.17,
    rx: 5,
    transform: "rotate(45 116.83 11.17)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimerDefault);
export default ForwardRef;